import { UserContext } from "../../App";
import CheckToken from "../../_Login/CheckToken";

const { useContext } = require("react");
const { useNavigate, Link } = require("react-router-dom");

const OilerTestDiagrams = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const FourPointImage = () => {
        return (
            <div className="card mb-3" style={{ margin: "1%" }}>
                <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>4 Point</div>
                <div className="card-body text-primary d-flex flex-column">
                    <img src="/img/Oiler/4Point.png" alt="Four Point Test" />
                </div>
            </div>
        );
    };

    const TwelvePointImage = () => {
        return (
            <div className="card mb-3" style={{ margin: "1%" }}>
                <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>12 Point</div>
                <div className="card-body text-primary d-flex flex-column">
                    <img src="/img/Oiler/12Point.png" alt="Twelve Point Test" />
                </div>
            </div>
        );
    }

    const handlePrint = () => {
        window.print();
    };

    return (

        <div className="testDiagrams">

            {user.email &&
                <div className="container body-content" style={{ marginTop: "25px" }}>

                    <div className="no-print" style={{ marginBottom: "8px" }}>
                        <Link to="/Oilers" className="btn btn-default" style={{ width: "auto" }}>Oilers</Link>
                        <button onClick={handlePrint} className="btn btn-primary" style={{ width: "132px", marginLeft: "8px" }}>Print This Page</button>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", margin: "0px", justifyContent: "space-between" }}>

                        <FourPointImage />

                        <TwelvePointImage />

                    </div>
                </div>

            }
        </div>
    );
}

export default OilerTestDiagrams;